"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _constants = require("../constants/constants");
var _product = require("../apis/shopify/product");
var _utils = require("../utils/utils");
var _fetchPromise = require("../apis/bwa/fetch-promise");
var _bwaEventLogger = _interopRequireDefault(require("./bwa-event-logger"));
var _gaEvents = require("../constants/ga-events");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var PdpGaEventHandler = {
  attachEvents: function attachEvents() {
    var _this = this;
    window.addEventListener(_constants.EVENT_TYPE.CUSTOM.BWA_PRODUCT_VIEWED, function (event) {
      if (event.target !== window && event.target !== document) {
        console.warn('Rejected message from unauthorized origin:', event.origin);
        return;
      }
      _this.sendPdpGaEvent({
        eventName: _gaEvents.BWA_PRODUCT_VIEWED,
        bwaEnabled: event.detail.bwaEnabled,
        reviewsEnabled: event.detail.reviewsEnabled,
        ratingsEnabled: event.detail.ratingsEnabled,
        shouldIncludeInventoryData: true
      })["catch"](function (error) {
        console.error("[BwA] Error while sending ga events", error);
      });
    });
    window.addEventListener(_constants.EVENT_TYPE.CUSTOM.NATIVE_ADD_TO_CART_BUTTON_SUBMIT, function () {
      return _this.sendPdpGaEvent({
        eventName: _gaEvents.NATIVE_ADD_TO_CART_BUTTON_SUBMIT,
        shouldIncludeInventoryData: true
      });
    });
    window.addEventListener(_constants.EVENT_TYPE.CUSTOM.PRODUCT_RATINGS_RENDER, function () {
      return _this.sendPdpGaEvent({
        eventName: _gaEvents.BWA_PRODUCT_RATINGS_RENDER
      });
    });
    window.addEventListener(_constants.EVENT_TYPE.CUSTOM.PRODUCT_REVIEWS_RENDER, function () {
      return _this.sendPdpGaEvent({
        eventName: _gaEvents.BWA_PRODUCT_REVIEWS_RENDER
      });
    });
    window.addEventListener(_constants.EVENT_TYPE.CUSTOM.BWA_DELIVERY_BLOCK_IFRAME_RENDER, function () {
      return _this.sendPdpGaEvent({
        eventName: _gaEvents.BWA_DELIVERY_BLOCK_RENDER
      });
    });
    window.addEventListener(_constants.EVENT_TYPE.CUSTOM.BWA_CLICK_UPDATE_ADDRESS_PDP, function () {
      return _this.sendPdpGaEvent({
        eventName: _gaEvents.BWA_CLICK_UPDATE_ADDRESS_PDP
      });
    });
    window.addEventListener(_constants.EVENT_TYPE.CUSTOM.BWA_CLICK_APPLY_PINCODE_BUTTON, function () {
      return _this.sendPdpGaEvent({
        eventName: _gaEvents.BWA_CLICK_APPLY_PINCODE_BUTTON
      });
    });
    window.addEventListener(_constants.EVENT_TYPE.CUSTOM.BWA_POWERED_BY_AMAZON_IFRAME_RENDER, function () {
      return _this.sendPdpGaEvent({
        eventName: _gaEvents.BWA_POWERED_BY_AMAZON_RENDER
      });
    });
    window.addEventListener(_constants.EVENT_TYPE.CUSTOM.BWA_CLICK_POWERED_BY_AMAZON_INFO, function () {
      return _this.sendPdpGaEvent({
        eventName: _gaEvents.BWA_CLICK_POWERED_BY_AMAZON_INFO
      });
    });
    window.addEventListener(_constants.EVENT_TYPE.CUSTOM.CLICK_NATIVE_BUY_NOW_BUTTON, function () {
      return _this.sendPdpGaEvent({
        eventName: _gaEvents.CLICK_NATIVE_BUY_NOW_BUTTON,
        shouldIncludeInventoryData: true
      });
    });
    window.addEventListener(_constants.EVENT_TYPE.CUSTOM.BWA_ADD_ADDRESS_CHECKOUT_BLOCK_RENDER, function () {
      return _this.sendPdpGaEvent({
        eventName: _gaEvents.BWA_ADD_ADDRESS_CHECKOUT_BLOCK_RENDER
      });
    });
    window.addEventListener(_constants.EVENT_TYPE.CUSTOM.VIEW_BWA_CHECKOUT_SKU, function () {
      return _this.sendPdpGaEvent({
        eventName: _gaEvents.VIEW_BWA_CHECKOUT_SKU
      });
    });
  },
  sendPdpGaEvent: function () {
    var _sendPdpGaEvent = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var _product$variants, _variant$price, _inStock;
      var _ref,
        eventName,
        _ref$bwaEnabled,
        bwaEnabled,
        _ref$reviewsEnabled,
        reviewsEnabled,
        _ref$ratingsEnabled,
        ratingsEnabled,
        _ref$shouldIncludeInv,
        shouldIncludeInventoryData,
        variantId,
        product,
        variant,
        price,
        quantityInput,
        selectedQuantity,
        inStock,
        _fetchPromiseData$sku,
        fetchPromiseData,
        payload,
        _args = arguments;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _ref = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, eventName = _ref.eventName, _ref$bwaEnabled = _ref.bwaEnabled, bwaEnabled = _ref$bwaEnabled === void 0 ? null : _ref$bwaEnabled, _ref$reviewsEnabled = _ref.reviewsEnabled, reviewsEnabled = _ref$reviewsEnabled === void 0 ? null : _ref$reviewsEnabled, _ref$ratingsEnabled = _ref.ratingsEnabled, ratingsEnabled = _ref$ratingsEnabled === void 0 ? null : _ref$ratingsEnabled, _ref$shouldIncludeInv = _ref.shouldIncludeInventoryData, shouldIncludeInventoryData = _ref$shouldIncludeInv === void 0 ? false : _ref$shouldIncludeInv;
            variantId = (0, _utils.getVariantId)(window.bwaMerchantConfig.bwaDeliveryBlock.variantIdSelector); // Guard: product resolution can fail (e.g. a /pages/ vanity URL where `<path>.js`
            // 404s), returning a shape without `variants`. price is analytics-only, so degrade it
            // to null rather than throwing, and source item_id from the DOM-resolved variantId
            // (equal to the matched variant's id by the find predicate) so the event still fires.
            _context.next = 4;
            return (0, _product.fetchProduct)();
          case 4:
            product = _context.sent;
            variant = product === null || product === void 0 || (_product$variants = product.variants) === null || _product$variants === void 0 ? void 0 : _product$variants.find(function (v) {
              return String(v.id) === String(variantId);
            });
            price = (_variant$price = variant === null || variant === void 0 ? void 0 : variant.price) !== null && _variant$price !== void 0 ? _variant$price : null;
            quantityInput = (0, _utils.safeQuerySelector)(window.bwaMerchantConfig.bwaDeliveryBlock.itemQuantitySelector);
            selectedQuantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
            inStock = false;
            if (!shouldIncludeInventoryData) {
              _context.next = 15;
              break;
            }
            _context.next = 13;
            return (0, _fetchPromise.fetchPromiseV2)(window.storeId, [{
              ecpSkuId: variantId,
              itemId: variantId,
              quantity: selectedQuantity
            }]);
          case 13:
            fetchPromiseData = _context.sent;
            inStock = (_fetchPromiseData$sku = fetchPromiseData.skuAvailabilityList[variantId]) === null || _fetchPromiseData$sku === void 0 ? void 0 : _fetchPromiseData$sku.inStock;
          case 15:
            payload = _objectSpread(_objectSpread({
              ecp: _constants.ECP,
              currency: _constants.INR,
              value: price,
              ecp_store_id: window.storeId,
              is_meta_browser: String((0, _utils.isMetaBrowser)()),
              is_bwa_repeat_customer: String((0, _utils.isBwARepeatCustomer)())
            }, (0, _utils.getExperimentContext)()), {}, {
              bwa_enabled: bwaEnabled === null || bwaEnabled === void 0 ? void 0 : bwaEnabled.toString(),
              reviews_enabled: reviewsEnabled === null || reviewsEnabled === void 0 ? void 0 : reviewsEnabled.toString(),
              ratings_enabled: ratingsEnabled === null || ratingsEnabled === void 0 ? void 0 : ratingsEnabled.toString(),
              bwa_inventory_available: (_inStock = inStock) === null || _inStock === void 0 ? void 0 : _inStock.toString(),
              items: [{
                item_id: variantId !== null && variantId !== void 0 ? variantId : null,
                price: price,
                quantity: selectedQuantity
              }]
            });
            Shopify.analytics.publish(eventName, payload);
            _bwaEventLogger["default"].logEvent(eventName, payload);
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function sendPdpGaEvent() {
      return _sendPdpGaEvent.apply(this, arguments);
    }
    return sendPdpGaEvent;
  }()
};
var _default = exports["default"] = PdpGaEventHandler;
//# sourceMappingURL=pdp-ga-event-handler.js.map
